import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const SalaryListAccordion = ({scheme, authData, isSalary=false, title, records, subheadSummary, activitiesSummary, statusKey="approval"}) => {
    const [activeCard, setActiveCard] = useState([]);
    const navigate = useNavigate();
      const months = [
        { id: 1, month: "January" },
        { id: 2, month: "February" },
        { id: 3, month: "March" },
        { id: 4, month: "April" },
        { id: 5, month: "May" },
        { id: 6, month: "June" },
        { id: 7, month: "July" },
        { id: 8, month: "August" },
        { id: 9, month: "September" },
        { id: 10, month: "October" },
        { id: 11, month: "November" },
        { id: 12, month: "December" },
      ];
      const mainCardSwitch = (val1, val2, val3, detailObj) => {
            setActiveCard((prev) => {
            let updated = [...prev];
            // Remove val2 and val3 if present
            updated = updated.filter((item) => item !== val2 && item !== val3);
            // Add val1 if not already present
            if (!updated.includes(val1)) {
                updated.unshift(val1); // Add at the beginning
            }
            return updated;
            });
        };

        const [activeKeys, setActiveKeys] = useState([]);
        
          const toggleAccordion = (key) => {
            setActiveKeys(
              (prevKeys) =>
                prevKeys.includes(key)
                  ? prevKeys.filter((k) => k !== key)
                  : [...prevKeys, key] 
            );
          };
    return (
        <Accordion style={{ border: "0" }}>
            <Accordion.Item
            eventKey={`${title.replace(" ", "").toLowerCase()}_${scheme.scheme_id}`}
            style={{ borderRadius: "0", border: "0" }}
            >
                <Accordion.Header onClick={() => toggleAccordion(`${title.replace(" ", "").toLowerCase()}_${scheme.scheme_id}`)} >
                    <div className="w-100 d-flex justify-content-between">
                    <span>{title}</span>
                    <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{
                        height: "13.33px",
                        width: "13.33px",
                        }}
                    >
                        {activeKeys.includes(`${title.replace(" ", "").toLowerCase()}_${scheme.scheme_id}`) ? "-" : "+"}
                    </span>
                    </div>
                </Accordion.Header>

                <Accordion.Body>
                    {
                        records.map((record, empIndex) => (
                            <div className="row p-0" key={empIndex} style={{border: "1px solid #e0e0e0", borderRadius: "4px", margin: "10px 0px 10px 0px"}}>
                                <div className="row p-0 m-0">
                                    <div className="col d-flex flex-column py-2">
                                        <span className="text-black-60 fs-12px">
                                        Sanction Order No.
                                        </span>
                                        <span className="fw-500 fs-14px">{record.sanction_order_no}</span>
                                    </div>
                                    <div className="col d-flex flex-column py-2">
                                        <span className="text-black-60 fs-12px">
                                        Sanction Order Date
                                        </span>
                                        <span className="fw-500 fs-14px">{record.sanction_order_date}</span>
                                    </div>
                                    <div className="col d-flex flex-column py-2">
                                        <span className="text-black-60 fs-12px">
                                        Month Year
                                        </span>
                                        <span className="fw-500 fs-14px">{months.find(e => e.id === Number(record.salary_month))?.month}</span>
                                    </div>
                                    <div className="col d-flex flex-column py-2">
                                        <span className="text-black-60 fs-12px">
                                        Employee Type
                                        </span>
                                        <span className="fw-500 fs-14px">{record.salary_type}</span>
                                    </div>
                                    <div className="col d-flex flex-column py-2">
                                        <span className="text-black-60 fs-12px">
                                        Total Employee
                                        </span>
                                        <span className="fw-500 fs-14px">{record.employee_count}</span>
                                    </div>
                                </div>
                                {isSalary && <div className="row p-0 m-0">
                                    <div className="col d-flex flex-column py-2">
                                        <span className="text-black-60 fs-12px">
                                        Invoice No.
                                        </span>
                                                        <span className="fw-500 fs-14px">{record.invoice_no}</span>
                                                    </div>
                                                    <div className="col d-flex flex-column py-2">
                                                        <span className="text-black-60 fs-12px">
                                                        Invoice Date
                                                        </span>
                                                        <span className="fw-500 fs-14px">{record.invoice_date}</span>
                                                    </div>
                                                    <div className="col d-flex flex-column py-2">
                                                        <span className="text-black-60 fs-12px">
                                                        Invoice Amount
                                                        </span>
                                                        <span className="fw-500 fs-14px">{record.gross_amount}</span>
                                                    </div>
                                                    <div className="col d-flex flex-column py-2">
                                                        <span className="text-black-60 fs-12px">
                                                        IGST
                                                        </span>
                                                        <span className="fw-500 fs-14px">{record.igst}</span>
                                                    </div>
                                                    <div className="col d-flex flex-column py-2">
                                                        <span className="text-black-60 fs-12px">
                                                        CGST
                                                        </span>
                                                        <span className="fw-500 fs-14px">{record.cgst}</span>
                                                    </div>
                                                    <div className="col d-flex flex-column py-2">
                                                        <span className="text-black-60 fs-12px">
                                                        SGST
                                                        </span>
                                                        <span className="fw-500 fs-14px">{record.sgst}</span>
                                                    </div>
                                                    <div className="col d-flex flex-column py-2">
                                                        <span className="text-black-60 fs-12px">
                                                        Invoice Value
                                                        </span>
                                                        <span className="fw-500 fs-14px">{record.invoice_value}</span>
                                                    </div>
                                                </div>
                                }
                                


                                <div className="row m-0 p-0">
                                    <div className="col d-flex align-items-center justify-content-center py-2 gap-1 ">
                                    <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                                        Creation Date:
                                    </span>
                                    <span className="fw-500 fs-14px d-flex align-items-center">
                                        {moment(record.created_at, 'YYYY-MM-DD').format("DD MMMM YYYY")}
                                    </span>
                                    </div>

                                    <div className="col d-flex py-2 gap-1 alitgn-items-center">
                                    <span className="text-prime-100 fs-12px d-flex justify-content-between align-items-center">
                                        Gross Amount:
                                    </span>
                                    <span className="fw-500 fs-14px d-flex align-items-center">
                                        {Number(record.gross_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                    </span>
                                    </div>

                                    <div className="col d-flex py-2 gap-1 ">
                                    <span className="text-danger-100 fs-12px d-flex justify-content-between align-items-center">
                                        Total Deduction:
                                    </span>
                                    <span className="fw-500 fs-14px d-flex align-items-center">
                                        {Number(record.deduction_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                    </span>
                                    </div>

                                    <div className="col d-flex py-2 gap-1 ">
                                    <span className="text-danger-100 fs-12px d-flex justify-content-between align-items-center">
                                        Total Payment:
                                    </span>
                                    <span className="fw-500 fs-14px d-flex align-items-center">
                                        {Number(record.payable_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                    </span>
                                    </div>

                                    <div className="col d-flex py-2 gap-1 ">

                                    <div className="d-flex align-items-center gap-1 ">
                                        <span
                                        className={`rounded-2 ${(record[`l2_${statusKey}`] === '1') ? 'bg-success-20' : (record[`l2_${statusKey}`] === '0') ? 'bg-danger-20' : 'bg-warning-20'}  d-flex align-items-center px-2 gap-1`}
                                        onClick={() => { Number(record[`l2_${statusKey}`]) === 0 && 
                                        navigate(`/view-salary${statusKey.includes('payment') ? '/payment' : ''}/${record.id}`); }}
                                        >
                                            <span className="fs-12px text-black-60">L2</span>
                                            <span>
                                                <i
                                                className={`${(record[`l2_${statusKey}`] === '1') ? 'icon-verified text-success-100' : (record[`l2_${statusKey}`] === '0') ? 'icon-warning_amber text-danger-100' : 'icon-warning_amber text-warning-100'}`}
                                                style={{ height: "14px", width: "14px" }}
                                                ></i>
                                            </span>
                                        </span>

                                        <span
                                        className={`${(record[`l3_${statusKey}`] === '1') ? 'bg-success-20' : (record[`l3_${statusKey}`] === '0') ? 'bg-danger-20' : 'bg-warning-20'} rounded-2   d-flex align-items-center px-2   gap-1`}
                                        onClick={() => { Number(record[`l3_${statusKey}`]) === 0 && navigate(`/view-salary${statusKey.includes('payment') ? '/payment' : ''}/${record.id}`); }}
                                        >
                                        <span className="fs-12px text-black-60">
                                            L3
                                        </span>
                                        <span>
                                            <i
                                            className={`${(record[`l3_${statusKey}`] === '1') ? 'icon-verified text-success-100' : (record[`l3_${statusKey}`] === '0') ? 'icon-warning_amber text-danger-100' : 'icon-warning_amber text-warning-100'}`}
                                            style={{ height: "14px", width: "14px" }}
                                            ></i>
                                        </span>
                                        </span>

                                        <span>
                                        <div className="d-flex gap-1 align-items-center">
                                            <i onClick={() => navigate(`/view-salary/${record.id}`)} className="icon-remove_red_eye text-info-100"></i>
                                            {
                                                authData.user.user_type === 'l1' && (record[`l2_${statusKey}`] === '0' || record[`l3_${statusKey}`] === '0') && <i className="icon-edit text-success-100"></i>
                                            }
                                        </div>
                                        </span>
                                    </div>
                                    </div>
                                </div>
                                <div className="px-2 m-0">
                                <div className="border mb-2"></div>
                                </div>
                            </div>
                        ))
                    }
                                <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                                    <button
                                        onClick={() =>
                                        mainCardSwitch(
                                            `subhead_${scheme.scheme_id}`,
                                            `activity_${scheme.scheme_id}`,
                                            `subactivity_${scheme.scheme_id}`,
                                            {
                                            scheme_id: scheme.scheme_id,
                                            subhead: true,
                                            activity: false,
                                            subActivity: false,
                                            }
                                        )
                                        }
                                        className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                        activeCard.includes(`subhead_${scheme.scheme_id}`)
                                            ? "bg-secondary-20"
                                            : "bg-white"
                                        } `}
                                    >
                                        {activeCard.includes(`subhead_${scheme.scheme_id}`) ? (
                                        <i className="icon-remove_circle_outline"></i>
                                        ) : (
                                        <i className="icon-add_circle_outline"></i>
                                        )}
                                        Sub head
                                    </button>
                                    
                                    <>
                                    <button
                                        onClick={() =>
                                        mainCardSwitch(
                                            `activity_${scheme.scheme_id}`,
                                            `subhead_${scheme.scheme_id}`,
                                            `subactivity_${scheme.scheme_id}`,
                                            {
                                            scheme_id: scheme.scheme_id,
                                            subhead: false,
                                            activity: true,
                                            subActivity: false,
                                            }
                                        )
                                        }
                                        className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                        activeCard.includes(`activity_${scheme.scheme_id}`)
                                            ? "bg-secondary-20"
                                            : "bg-white"
                                        } `}
                                    >
                                        {activeCard.includes(`activity_${scheme.scheme_id}`) ? (
                                        <i className="icon-remove_circle_outline"></i>
                                        ) : (
                                        <i className="icon-add_circle_outline"></i>
                                        )}
                                        Activity
                                    </button>
                                
                                    <button
                                        onClick={() =>
                                        mainCardSwitch(
                                            `subactivity_${scheme.scheme_id}`,
                                            `activity_${scheme.scheme_id}`,
                                            `subhead_${scheme.scheme_id}`,
                                            {
                                            scheme_id: scheme.scheme_id,
                                            subhead: false,
                                            activity: false,
                                            subActivity: true,
                                            }
                                        )
                                        }
                                        className={` ${
                                        activeCard.includes(`subactivity_${scheme.scheme_id}`)
                                            ? "bg-secondary-20"
                                            : "bg-white"
                                        } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                    >
                                        {activeCard.includes(`subactivity_${scheme.scheme_id}`) ? (
                                        <i className="icon-remove_circle_outline"></i>
                                        ) : (
                                        <i className="icon-add_circle_outline"></i>
                                        )}
                                        Sub-Activity
                                    </button>
                                    </>
                                </div>

                                {activeCard.includes(`subhead_${scheme.scheme_id}`) && (
                                    <div className="p-0 m-0">
                                        <div className="row m-0 p-0">
                                        <div className="col-3">
                                            <span className="text-black-60 fs-12px">
                                            Subhead code
                                            </span>
                                        </div>
                                        <div className="col-3">
                                            <span className="text-black-60 fs-12px">
                                            Total Gross Amount
                                            </span>
                                        </div>
                                        <div className="col-3">
                                            <span className="text-black-60 fs-12px">
                                            Total Deductions
                                            </span>
                                        </div>
                                        <div className="col-3">
                                            <span className="text-black-60 fs-12px">
                                            Total Payment
                                            </span>
                                        </div>
                                        </div>
                                        {
                                            subheadSummary.map((subhead, subheadIndex) => (
                                                <div className="row p-0 m-0" key={subheadIndex}>
                                                    <div className="col-3">
                                                        <span className="fw-500 fs-14px">{subhead.subhead_name}</span>
                                                    </div>
                                                    <div className="col-3">
                                                        <span className="fw-500 fs-14px">{Number(subhead.total_gross_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                                                    </div>
                                                    <div className="col-3">
                                                        <span className="fw-500 fs-14px">{Number(subhead.total_deduction_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                                                    </div>
                                                    <div className="col-3">
                                                        <span className="fw-500 fs-14px">{Number(subhead.total_payable_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                        
                                    </div>
                                )}
                                {activeCard.includes(`activity_${scheme.scheme_id}`) && (
                                <div>
                                    {
                                        subheadSummary.map((subhead, subheadIndex) => (
                                            <Accordion style={{ border: "0" }} key={subheadIndex}>
                                                <Accordion.Item eventKey={`${title.replace(" ", "").toLowerCase()}_${subhead.subhead_id}`} style={{ borderRadius: "0", border: "0" }}>
                                                    <Accordion.Header
                                                    onClick={() => toggleAccordion(`${title.replace(" ", "").toLowerCase()}_${subhead.subhead_id}`)}
                                                    >
                                                    <div className="w-100 d-flex justify-content-between">
                                                        <span>{subhead.subhead_name}</span>
                                                        <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                        }}
                                                        >
                                                        {activeKeys.includes(`${title.replace(" ", "").toLowerCase()}_${subhead.subhead_id}`) ? "-" : "+"}
                                                        </span>
                                                    </div>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className="p-0 m-0">
                                                            <div className="row m-0 p-0">
                                                                <div className="col-3">
                                                                    <span className="text-black-60 fs-12px">Activity Name</span>
                                                                </div>
                                                                <div className="col-3">
                                                                    <span className="text-black-60 fs-12px">Total Gross Amount</span>
                                                                </div>
                                                                <div className="col-3">
                                                                    <span className="text-black-60 fs-12px">Total Deductions</span>
                                                                </div>
                                                                <div className="col-3">
                                                                    <span className="text-black-60 fs-12px">Total Payment</span>
                                                                </div>
                                                            </div>
                                                            {
                                                                activitiesSummary.map((activity, actIndex) => {
                                                                    if(activity.subhead_id === subhead.subhead_id) {
                                                                        return (
                                                                            <div className="row p-0 m-0" key={actIndex}>
                                                                                <div className="col-3">
                                                                                    <span className="fw-500 fs-14px">{activity.activity}</span>
                                                                                </div>
                                                                                <div className="col-3">
                                                                                    <span className="fw-500 fs-14px">{activity.total_gross_amount}</span>
                                                                                </div>
                                                                                <div className="col-3">
                                                                                    <span className="fw-500 fs-14px">{activity.total_deduction_amount}</span>
                                                                                </div>
                                                                                <div className="col-3">
                                                                                    <span className="fw-500 fs-14px">{activity.total_payable_amount}</span>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        ))
                                    }
                                </div>
                                )}
                                {activeCard.includes(`subactivity_${scheme.scheme_id}`) && (
                                    <>
                                        {
                                            subheadSummary.map((subhead, subheadIndex) => (
                                                // Filter activities of this subhead, then render
                                                activitiesSummary
                                                .filter(activity => activity.subhead_id === subhead.subhead_id)
                                                .map((activity, actIndex) => {
                                                    const eventKey = `ag-${scheme.scheme_id}-${subhead.subhead_id}-${activity.activity_id}-${actIndex}`;
                                                    const activityLabel = activity.activity_name || activity.activity || ""; // safe
                                                    const activityCode  = activity.activity_code || ""; // if you have it

                                                    return (
                                                    <Accordion key={eventKey} activeKey={activeKeys} style={{ border: "0" }}>
                                                        <Accordion.Item eventKey={eventKey} style={{ borderRadius: "0", border: "0" }}>
                                                            <Accordion.Header onClick={() => toggleAccordion(eventKey)}>
                                                                <div className="w-100 d-flex justify-content-between">
                                                                <span>
                                                                    {subhead.subhead_name} | {activityLabel}
                                                                    {activityCode ? `, ${activityCode}` : ""}
                                                                </span>
                                                                <span
                                                                    className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                                    style={{ height: "13.33px", width: "13.33px" }}
                                                                >
                                                                    {activeKeys.includes(eventKey) ? "-" : "+"}
                                                                </span>
                                                                </div>
                                                            </Accordion.Header>

                                                            <Accordion.Body>
                                                                <div className="p-0 m-0">
                                                                    <div className="row m-0 p-0">
                                                                        <div className="col-3">
                                                                        <span className="text-black-60 fs-12px">Sub Activity</span>
                                                                        </div>
                                                                        <div className="col-3">
                                                                        <span className="text-black-60 fs-12px">Total Gross Amount</span>
                                                                        </div>
                                                                        <div className="col-3">
                                                                        <span className="text-black-60 fs-12px">Total Deductions</span>
                                                                        </div>
                                                                        <div className="col-3">
                                                                        <span className="text-black-60 fs-12px">Total Payment</span>
                                                                        </div>
                                                                    </div>

                                                                    {(activity.subactivities || []).map((subactivity, subactIndex) => (
                                                                        <div className="row p-0 m-0" key={`${eventKey}-sub-${subactivity.subactivity_id || subactIndex}`}>
                                                                        <div className="col-3">
                                                                            <span className="fw-500 fs-14px">
                                                                            {subactivity.subactivity || "—"}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <span className="fw-500 fs-14px">
                                                                            {Number(subactivity.total_gross_amount || 0).toLocaleString("en-IN")}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <span className="fw-500 fs-14px">
                                                                            {Number(subactivity.total_deduction_amount || 0).toLocaleString("en-IN")}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <span className="fw-500 fs-14px">
                                                                            {Number(subactivity.total_payable_amount || 0).toLocaleString("en-IN")}
                                                                            </span>
                                                                        </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    </Accordion>
                                                    );
                                                })
                                            ))
                                        }
                                    </>
                                )}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}

export default SalaryListAccordion;